import React, {useState, useEffect} from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { getProtondxAdminOrgList } from '../../redux-store/actions/protondxAdminActions'
import { logOutUser } from '../../redux-store/actions/authActions'
import { useAuth0 } from '@auth0/auth0-react'

const NavigationBar = (props) => {

    const [orgKey, setOrgKey] = useState('0')
    const history = useHistory()
    const {userInfo} = useSelector(state=>state.logIn)
    const {orgoptions} = useSelector(state=>state.protondxAdminOrgList)
    const { processing, userauth, error } = useSelector((state)=>state.logOut)

    useEffect(() => {
       dispatch(getProtondxAdminOrgList(0, 10))
    }, [])

    useEffect(() => {
      console.log(userauth)
      if(typeof(userauth) !== 'undefined'){
        if(userauth !== null){
          localStorage.removeItem('userInfo')
          logout()
        }
      }
    }, [userauth])

    const handleLogout = ()=>{
        // localStorage.removeItem('userInfo')
        // logout()
        //Remove access token here from the server
        dispatch(logOutUser())
    }

    const showSettings = ()=>{
      if(props.setSettingData){
        props.setSettingData(true)
      }else{
        alert("Switch to Organization Dashboard Tab")
      }
    }

    const {logout, user, isLoading,} =useAuth0()

    const dispatch = useDispatch()
    return (
        <div className='protondx-navbar'>
            <div className="topmenu" style={{paddingTop: "1vh"}}>
              <p className='top-logo' style={{pointerEvents: 'none'}}></p>
              { JSON.parse(localStorage.getItem('userInfo')).permission_group === "PROTON_DX_ADMIN" ?
              <div style={{padding: "8px", cursor: "pointer"}} onClick={() => showSettings()}><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M12.9392 0C12.1107 0 11.4392 0.671573 11.4392 1.5V3.30322C11.4392 3.32775 11.4398 3.35213 11.4409 3.37637C10.571 3.63511 9.74191 3.98749 8.96564 4.4217C8.93649 4.38706 8.90551 4.35341 8.8727 4.3209L7.57609 3.0361C6.98763 2.453 6.03354 2.453 5.44508 3.0361L2.44295 6.01088C1.85449 6.59398 1.85449 7.53937 2.44295 8.12247L3.73956 9.40727C3.82185 9.4888 3.91128 9.55893 4.00586 9.61766C3.73219 10.1678 3.49952 10.7416 3.31179 11.3351H1.5C0.671573 11.3351 0 12.0067 0 12.8351V17.0283C0 17.8568 0.671572 18.5283 1.5 18.5283H3.29775C3.56464 19.3838 3.92483 20.1987 4.36653 20.9614L3.02974 22.1985C2.42174 22.7612 2.38949 23.7061 2.95771 24.3089L5.85503 27.3828C6.42325 27.9856 7.37677 28.0182 7.98477 27.4555L9.32555 26.2146C9.44936 26.1 9.54929 25.9696 9.62514 25.8294C10.1466 26.0807 10.6889 26.2963 11.2487 26.4729C11.2378 26.5459 11.2321 26.6207 11.2321 26.6967V28.4999C11.2321 29.3284 11.9037 29.9999 12.7321 29.9999H16.9915C17.8199 29.9999 18.4915 29.3284 18.4915 28.4999V26.6967C18.4915 26.6392 18.4883 26.5825 18.482 26.5267C19.0887 26.3453 19.6754 26.1183 20.2382 25.8498C20.2929 25.9315 20.3566 26.009 20.4293 26.081L21.7259 27.3658C22.3144 27.9489 23.2684 27.9489 23.8569 27.3658L26.859 24.391C27.4475 23.8079 27.4475 22.8626 26.859 22.2795L25.5624 20.9947C25.5534 20.9858 25.5444 20.977 25.5353 20.9684C25.9789 20.2036 26.3406 19.3861 26.6083 18.5277C26.6229 18.5281 26.6376 18.5283 26.6523 18.5283H28.4997C29.3281 18.5283 29.9997 17.8568 29.9997 17.0283V12.8351C29.9997 12.0067 29.3282 11.3351 28.4997 11.3351H26.6523C26.6329 11.3351 26.6136 11.3355 26.5944 11.3362C26.4174 10.7765 26.2005 10.2343 25.9468 9.71288C26.053 9.65467 26.1538 9.58271 26.2465 9.4969L27.5873 8.25605C28.1953 7.69335 28.2275 6.7485 27.6593 6.14566L24.762 3.07181C24.1938 2.46897 23.2402 2.43642 22.6322 2.99911L21.2915 4.23997C21.2067 4.31845 21.1331 4.40437 21.0707 4.49576C20.3243 4.06613 19.5277 3.71272 18.6918 3.44625C18.6962 3.39918 18.6985 3.35147 18.6985 3.30322V1.5C18.6985 0.671573 18.027 0 17.1985 0H12.9392ZM14.9868 22.3291C19.0781 22.3291 22.3948 19.0426 22.3948 14.9886C22.3948 10.9345 19.0781 7.64808 14.9868 7.64808C10.8955 7.64808 7.57882 10.9345 7.57882 14.9886C7.57882 19.0426 10.8955 22.3291 14.9868 22.3291Z" fill="#24b34b"/>
<path fillRule="evenodd" clipRule="evenodd" d="M14.9544 21.0998C18.3417 21.0998 21.0876 18.379 21.0876 15.0226C21.0876 11.6662 18.3417 8.94531 14.9544 8.94531C11.5672 8.94531 8.82129 11.6662 8.82129 15.0226C8.82129 18.379 11.5672 21.0998 14.9544 21.0998ZM14.9548 20.4169C17.9614 20.4169 20.3988 18.0017 20.3988 15.0224C20.3988 12.0432 17.9614 9.62802 14.9548 9.62802C11.9481 9.62802 9.51074 12.0432 9.51074 15.0224C9.51074 18.0017 11.9481 20.4169 14.9548 20.4169Z" fill="#24b34b"/>
</svg></div>
: ""
}
              {userInfo && (
                <button
                    className='circle'
                    onClick={handleLogout}
                >
                    Logout
                </button>
            )}
            </div>
        </div>
    )
}

export default NavigationBar
